import type { StackProps } from '@mantine/core'
import { Badge, Group, Stack, Text } from '@mantine/core'
import type { ReactNode } from 'react'

import { InputLabel } from '@/components/InputLabel'
import type { TranscriptSpeaker } from '@/utils/transcript'

interface SpeakerListProps extends StackProps {
  speakers: TranscriptSpeaker[]
  /** Rendered opposite the heading, e.g. the "Identify Speakers" button. */
  action?: ReactNode
}

export function SpeakerList(props: SpeakerListProps) {
  const { speakers, action, ...stackProps } = props

  if (speakers.length === 0) return null

  return (
    <Stack gap="xs" {...stackProps}>
      <Group justify="space-between">
        <InputLabel label="Speaker List" />
        {action}
      </Group>

      <Stack gap="xs">
        {speakers.map(speaker => (
          <Group key={speaker.label} gap="sm" wrap="nowrap">
            <Badge variant="light" color="gray" radius="sm" size="lg" style={{ flexShrink: 0 }}>
              Speaker {speaker.speakerNumber}
            </Badge>
            <Text size="sm" c={speaker.name ? undefined : 'dimmed'} fs={speaker.name ? undefined : 'italic'}>
              {speaker.name ?? 'Unnamed'}
            </Text>
          </Group>
        ))}
      </Stack>

      <Text size="xs" c="dimmed">
        Speakers detected in this file. Use Identify Speakers to update these names.
      </Text>
    </Stack>
  )
}
